export default "data:image/gif;base64,R0lGODlhCAAMAIABAAAAAAAAACH5BAEAAAEALAAAAAAIAAwAAAIUTIBot+wGYIsn0TdbTfpC22lSUwAAOw=="